import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import LeaseRateCardViewModel from '@app/models/lease-rate-card-view-model';
import ListingContactViewModel2 from '@app/models/listing-contact-view-model2';
import ListingViewModel from '@app/models/listing-view-model';
import { ListingContactService, ListingService, NotificationService, RouteHelperService } from '@app/services';

import { Router, Event, ActivatedRoute } from '@angular/router';
import { NavigationStart, NavigationError, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { OAPopoverComponent } from '../../../common-components/oapopover/oapopover.component';
import { SpinnerComponent } from '../../../common-components/spinner/spinner.component';
import { NgIf, PercentPipe, CurrencyPipe } from '@angular/common';

interface ISeasonalLeaseSubject {
  acres: number;
  subject: any;
  canSave: boolean;
}

@Component({
    selector: "seasonal-lease-rate-calculator",
    templateUrl: "./seasonal-lease-rate-calculator.component.html",
    styleUrls: ["./seasonal-lease-rate-calculator.component.less"],
    imports: [NgIf, SpinnerComponent, OAPopoverComponent, FormsModule, PercentPipe, CurrencyPipe]
})
export class SeasonalLeaseRateCalculatorComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'SeasonalLeaseRateCalculatorComponent';
  private _selectedContact: ListingContactViewModel2;
  private _listing: ListingViewModel;

  public savingLeaseRate: boolean;

  public initialized = false;

  @Input()
  public inputColumnName = 'Current';

  private routerEventsSubscription: Subscription;

  public get selectedContact(): ListingContactViewModel2 {
    return this._selectedContact;
  }
  @Input()
  public set selectedContact(v: ListingContactViewModel2) {
    this._selectedContact = v;

    if (v) {
      this.model = {
        acres: v.totalAcres,
        canSave: true,
        subject: v,
      } as ISeasonalLeaseSubject;

      this.initialized = true;
    }
  }

  public get listing(): ListingViewModel {
    return this._listing;
  }
  @Input()
  public set listing(v: ListingViewModel) {
    this._listing = v;

    this.model = {
      acres: v.acres,
      canSave: false,
      subject: v,
    } as ISeasonalLeaseSubject;
  }

  @Input()
  public model: ISeasonalLeaseSubject;

  @Input()
  public editLeaseRate: LeaseRateCardViewModel;

  @Input()
  public calcLeaseRate: LeaseRateCardViewModel;

  constructor(
    private notify: NotificationService,
    private listingContactService: ListingContactService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private routeHelper: RouteHelperService,
    private listingService: ListingService
  ) {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        //do something on start activity
      }
      if (event instanceof NavigationError) {
        // Handle error
        console.error(event.error);
      }
      if (event instanceof NavigationEnd) {
        //do something on end activity
        console.log(`${this._componentName}.CTOR - routerEventsSubscription - urlAfterRedirects=`, event.urlAfterRedirects);

        // Only sniff the route if we have no model
        if (!this.model) {
          const listingId = +this.routeHelper.getRouteParameter(this.route, 'id');

          if (listingId) {
            this.listingService.getAsViewModel(listingId).subscribe(
              (result) => {
                console.log(`${this._componentName}.CTOR - routerEventsSubsgetAsViewModelcription - result=`, result);

                this.listing = result;

                this.calculateListingLeaseRate();

                if (!this.model.canSave) {
                  this.inputColumnName = 'Adjusted';
                }

                this.initialized = true;
              },
              (err) => {
                console.error(err);
                
                this.notify.error('A subscription error occured', null);
              }
            );
          }
        } else {
          this.initialized = true;
        }
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  public get editLeaseRatePercent(): number {
    return Math.round(this.editLeaseRate.oaLeaseRatio * 100);
  }
  public set editLeaseRatePercent(v: number) {
    if (v >= 0) {
      this.editLeaseRate.oaLeaseRatio = v / 100;
    } else {
      this.editLeaseRate.oaLeaseRatio = null;
    }
  }

  public onSaveLeaseRateEditClick() {
    console.log(`${this._componentName}.onSaveLeaseRateEditClick`);

    var contactData = this.listingContactService.getContactData(this.selectedContact);
    contactData.leaseRate = this.editLeaseRate;

    this.savingLeaseRate = true;

    this.listingContactService.updateContactData(this.selectedContact.id, contactData).subscribe(
      (result) => {
        console.log(`${this._componentName}.onSaveLeaseRateEditClick() -   listingContactService.updateContactData result=`, result);

        this.selectedContact.data = result.data;

        // this.leaseRate = { ...this.editLeaseRate };
        this.savingLeaseRate = false;
      },
      (err) => {
        console.error(err);
        this.savingLeaseRate = false;
        
        this.notify.error('A subscription error occured', null);
      }
    );
  }

  public onEditLeaseRateChange(evt: any) {
    console.log(`${this._componentName}.onEditLeaseRateChange evt=`, evt);

    this.editLeaseRate = this.calculateLeaseRate(this.model.acres, this.editLeaseRate);

    this.changeDetectorRef.detectChanges();
  }

  /**
   * Calculate a lease rate
   */
  private calculateLeaseRate(actualAcres: number, leaseRate: LeaseRateCardViewModel) {
    let x: LeaseRateCardViewModel = { ...leaseRate };

    x.totalMemberAmount = leaseRate.maxMembers * leaseRate.memberAmount;

    // x.totalLandAmount = leaseRate.maxAcres * leaseRate.amountPerAcre;

    x.amountPerAcre = x.totalLandAmount / actualAcres;

    x.totalOAAmount = x.oaLeaseRatio * x.totalLandAmount + x.totalMemberAmount;
    x.totalLOAmount = (1 - x.oaLeaseRatio) * x.totalLandAmount;

    x.totalLeaseAmount = x.totalOAAmount + x.totalLOAmount;
    x.perPersonAmount = x.totalLeaseAmount / x.maxMembers;
    x.totalPerAcre = x.totalLeaseAmount / x.maxAcres;

    x.oaTakeRate = x.totalOAAmount / x.totalLOAmount;

    return x;
  }

  public calculateListingLeaseRate() {
    console.log(`${this._componentName}.calculateListingLeaseRate()`);

    this.listingService.getLeaseRate(this.listing.id).subscribe(
      (result) => {
        console.log(`${this._componentName} subscription result=`, result);

        this.calcLeaseRate = result;
        this.editLeaseRate = { ...result };
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      }
    );
  }

  public onHeaderRowClick() {
    console.log(`${this._componentName}.onHeaderRowClick() `);

    //     console.log("leaseRate: ", this.leaseRate);
    console.log('editLeaseRate: ', this.editLeaseRate);

    // console.log("leaseRate.oaLeaseRatio: ", this.leaseRate.oaLeaseRatio);
    console.log('editLeaseRate.oaLeaseRatio: ', this.editLeaseRate.oaLeaseRatio);

    console.log('editLeaseRatePercent: ', this.editLeaseRatePercent);
  }
}
